import React from 'react';
import Section from '../../../pages/_components/sidePanel/Section.new';
import TextContentSection from '../../../components_profiles/TextContentSection';
import ContentCard from '../../../components_profiles/ContentCard';
import Category from '../../../pages/user/User/Category';
import Entry from '../../../pages/user/User/Entry';

export default function Reflections(props) {
  const { evaluation } = props;

  return (
    <ContentCard className="space-y-4">
      <Category>
        Reflections
      </Category>
      <div className="space-y-3">
        <Entry
          title="What led you to this learning journey?"
          description={evaluation.data.journey || '-'}
        />
        <Entry
          title="What adventures did you go on?"
          description={evaluation.data.adventures || '-'}
        />
        <Entry
          title="What challenges did you face along the way and how did you work to overcome them?"
          description={evaluation.data.challenges || '-'}
        />
        <Entry
          title="How were you, your students and/or your partners changed by this journey?"
          description={evaluation.data.changes || '-'}
        />
        <Entry
          title="Looking back, what lessons did you learn that might help other teachers about to begin their first community-engaged learning journey?"
          description={evaluation.data.lessons || '-'}
        />
      </div>
    </ContentCard>
  );

  return (
    <Section title="Reflections">
      <TextContentSection title="What led you to this learning journey?">
        {evaluation.data.journey || '-'}
      </TextContentSection>
      <TextContentSection title="What adventures did you go on?">
        {evaluation.data.adventures || '-'}
      </TextContentSection>
      <TextContentSection title="What challenges did you face along the way and how did you work to overcome them?">
        {evaluation.data.challenges || '-'}
      </TextContentSection>
      <TextContentSection title="How were you, your students and/or your partners changed by this journey?">
        {evaluation.data.changes || '-'}
      </TextContentSection>
      <TextContentSection title="Looking back, what lessons did you learn that might help other teachers about to begin their first community-engaged learning journey?">
        {evaluation.data.lessons || '-'}
      </TextContentSection>
    </Section>
  );
}
